"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        // tslint:disable-next-line: class-name
        var RowTemplate_Table = /** @class */ (function (_super) {
            __extends(RowTemplate_Table, _super);
            function RowTemplate_Table(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.$list = parent || {};
                _this._rowLabel = $dyn.observable();
                if (_this.DataSource && !_this.DataSource.parent) {
                    if (parent && parent.element && parent.element.dynChildren) {
                        _this.$index = parent.element.dynChildren().indexOf(element);
                        _this.usingDisposable($dyn.observe(function () {
                            var parentDataSource = $dyn.value(parent.DataSource);
                            if (parentDataSource) {
                                return $dyn.getFieldValue(_this.$list.RowLabelColumn, parentDataSource[_this.$index]);
                            }
                        }, function (label) {
                            _this._rowLabel(label);
                            // Changing of the row label may need the header to be re-laid out based on the new content size
                            $dyn.callFunction(_this.$list.scheduleHeaderLayout, _this.$list);
                        }));
                    }
                }
                return _this;
            }
            return RowTemplate_Table;
        }($dyn.ui.Control));
        controls.RowTemplate_Table = RowTemplate_Table;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=RowTemplate_Table.js.map
